// extracted by mini-css-extract-plugin
export default {"menuButton":"COpGyXlv4AQQjNjJrLRH","menuItems":"LIwdj2vbORuNrxcep92y","menuItem":"NGIM6fnr2uEwyoEwMAWZ","disabled":"m7EJRh4Z2mB8FHSTxEMR"};